export default __webpack_public_path__ + "static/media/pencil-bright-spring.3e3302e3.png";